import React from "react";
import { Icon } from "@iconify/react";
import style from "../../../scss/Dashboard.module.scss";

const formatoVotos = (valor) => valor.toLocaleString("es-CO");
const formatoPorcentaje = (valor) =>
  `${valor.toLocaleString("es-CO", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;

// Tarjeta de una corporación: quién va ganando, la ventaja sobre el segundo
// y el ranking de candidatos (barras relativas al que más votos lleva).
const DashboardCorporacionComponent = ({ resumen }) => {
  const { nombre, ranking, lider, segundo, empate, diferencia, diferenciaPuntos, maxVotos } = resumen;

  return (
    <article className={style.tarjeta}>
      <div className={style.cabecera}>
        <h2 className={style.corporacion}>{nombre}</h2>
        <span className={style.chip}>
          <Icon icon="mdi:ballot-outline" aria-hidden="true" />
          {resumen.mesasCerradas} de {resumen.mesasEscrutadas} mesas cerradas
        </span>
      </div>

      {lider ? (
        <div className={style.lider}>
          <p className={style.liderEtiqueta}>
            <Icon icon={empate ? "mdi:scale-balance" : "mdi:trophy-outline"} aria-hidden="true" />
            {empate ? "Empate" : "Va ganando"}
          </p>
          <p className={style.liderNombre}>{empate ? `${lider.nombre} y ${segundo.nombre}` : lider.nombre}</p>
          <p className={style.liderCifras}>
            <strong>{formatoPorcentaje(lider.porcentaje)}</strong>
            <span>{formatoVotos(lider.valor)} votos</span>
          </p>
        </div>
      ) : (
        <p className={style.vacio}>Aún no hay votos registrados para {nombre.toLowerCase()}.</p>
      )}

      <dl className={style.indicadores}>
        <div className={style.indicador}>
          <dt>Ventaja</dt>
          <dd>{lider && segundo ? `+${formatoVotos(diferencia)}` : "—"}</dd>
          <dd className={style.indicadorDetalle}>
            {lider && segundo
              ? `${diferenciaPuntos.toLocaleString("es-CO", { maximumFractionDigits: 1 })} pts sobre ${segundo.nombre}`
              : "Sin segundo lugar"}
          </dd>
        </div>
        <div className={style.indicador}>
          <dt>Votos válidos</dt>
          <dd>{formatoVotos(resumen.votosValidos)}</dd>
          <dd className={style.indicadorDetalle}>Candidatos + en blanco</dd>
        </div>
        <div className={style.indicador}>
          <dt>Total del acta</dt>
          <dd>{formatoVotos(resumen.totalGeneral)}</dd>
          <dd className={style.indicadorDetalle}>Incluye nulos y no marcados</dd>
        </div>
      </dl>

      <h3 className={style.subtitulo}>Votación por candidato</h3>
      {ranking.length === 0 ? (
        <p className={style.vacio}>No hay candidatos de {nombre.toLowerCase()} en el catálogo.</p>
      ) : (
        <ol className={style.ranking}>
          {ranking.map((candidato, indice) => (
            <li
              key={candidato.id}
              className={`${style.candidato} ${indice === 0 && lider ? style.candidatoLider : ""}`}
              title={`${candidato.nombre}: ${formatoVotos(candidato.valor)} votos (${formatoPorcentaje(candidato.porcentaje)} de los votos válidos)`}
            >
              <div className={style.candidatoFila}>
                <span className={style.puesto}>{indice + 1}</span>
                <span className={style.candidatoNombre}>{candidato.nombre}</span>
                <span className={style.candidatoValor}>
                  {formatoVotos(candidato.valor)}
                  <small>{formatoPorcentaje(candidato.porcentaje)}</small>
                </span>
              </div>
              <progress
                className={style.barra}
                value={candidato.valor}
                max={Math.max(maxVotos, 1)}
                aria-label={`Votos de ${candidato.nombre}`}
              />
            </li>
          ))}
        </ol>
      )}

      <dl className={style.especiales}>
        {resumen.especiales.map((especial) => (
          <div key={especial.id} className={style.especial}>
            <dt>{especial.nombre}</dt>
            <dd>{formatoVotos(especial.valor)}</dd>
          </div>
        ))}
      </dl>
    </article>
  );
};

export default DashboardCorporacionComponent;
